import {
  ApiBlueprint,
  createFrontendModule,
  featureFlagsApiRef,
} from '@backstage/frontend-plugin-api';
import { NEW_FRONTEND_SYSTEM_FLAG } from '@internal/frontend-common';
import { featureFlagsApi } from './featureFlags';

const featureFlagsModule = createFrontendModule({
  pluginId: 'app',
  featureFlags: [
    {
      name: NEW_FRONTEND_SYSTEM_FLAG,
      description:
        'Preview the new frontend system. It is not complete yet and shows a mix of new and old UI. The page reloads when you switch.',
    },
    {
      name: 'notifications',
      description:
        'Show the Notifications page and sidebar item. Notifications can currently only come from template runs.',
    },
    {
      name: 'experimental-templates',
      description:
        "Show experimental templates on the Create page. They are tagged 'experimental'.",
    },
    {
      name: 'dependency-graph-check',
      description:
        "Add a 'Check dependency graph' action to each repository's actions menu (⋮) on the Repositories page. It checks whether GitHub detects the repository's dependencies.",
    },
  ],
  extensions: [
    ApiBlueprint.make({
      name: 'feature-flags',
      params: defineParams =>
        defineParams({
          api: featureFlagsApiRef,
          deps: {},
          factory: () => featureFlagsApi,
        }),
    }),
  ],
});

export default featureFlagsModule;
